export class FileUploadEventModel {

  constructor(public status: string,
    public metadataId: string,
    public fileName: string,
  ) { }
}
